export default __webpack_public_path__ + "cf401286afa32f7c5f7ccf36d900e2dc.gif";